import {
  combine,
  polygon,
  polygonToGeoJSON,
  segments,
  selectDifference,
  selectIntersect,
  selectUnion,
  type Segment,
} from '@/modules/Editor/polygonOperations'

import type { Island, Pt, Ring } from './geometry'

const EMPTY: Segment = { segments: [], inverted: false }

const toRegions = (rings: Ring[]): number[][][] => rings.map((ring) => ring.map((p) => [p.x, p.y]))

// Normalises self-overlapping input the same way subtractPolygons does.
export const toSegment = (rings: Ring[]): Segment =>
  selectUnion(combine(segments({ regions: toRegions(rings), inverted: false }), EMPTY))

// GeoJSON rings repeat their first point at the end; islands keep rings open.
const toRing = (coordinates: number[][]): Ring =>
  coordinates.slice(0, -1).map(([x, y]): Pt => ({ x, y }))

export const islandsOf = (segment: Segment): Island[] => {
  const geoJSON = polygonToGeoJSON(polygon(segment))
  const polygons = geoJSON.type === 'Polygon' ? [geoJSON.coordinates] : geoJSON.coordinates
  return polygons
    .filter((rings) => rings.length)
    .map(([outer, ...holes]) => ({ outer: toRing(outer), holes: holes.map(toRing) }))
}

export const differenceIslands = (a: Segment, b: Segment): Island[] =>
  islandsOf(selectDifference(combine(a, b)))

export const intersectionIslands = (a: Segment, b: Segment): Island[] =>
  islandsOf(selectIntersect(combine(a, b)))
